export default function Services() {
  const services = [
    {
      id: 1,
      title: 'Gıda Etiketleri',
      description: 'FDA ve TSE onaylı gıda teması güvenli mürekkeplerle üretim. Dondurucudan buzdolabına, raf ortamından e-ticaret kolisine kadar her koşulda yapışan, solmayan etiketler. Besin değeri tablosu ve barkod tasarımı dahildir.',
      image: 'https://public.readdy.ai/ai/img_res/5042ccbc049a206bcb88c40d22cb0f97.jpg',
      color: 'from-green-50 to-emerald-50',
      icon: 'ri-restaurant-line'
    },
    {
      id: 2,
      title: 'Kozmetik Etiketleri',
      description: 'Banyo ortamının nemli koşullarına dayanıklı PP ve PET malzeme seçenekleri. Soft-touch laminasyon, sıcak folyo ve hologram kaplamalarla premium kozmetik algısı oluşturuyoruz. INCI listesi uyumlu tasarım garantisi.',
      image: 'https://readdy.ai/api/search-image?query=minimal%20skincare%20routine%20flatlay%20on%20pale%20pink%20textured%20surface%20featuring%20serum%20dropper%20bottle%20face%20cream%20jar%20and%20toner%20with%20clean%20white%20minimalist%20labels%20showing%20ingredients%20and%20brand%20name%20soft%20diffused%20morning%20light%20beauty%20photography&width=600&height=700&seq=svc-cosmetic-v2-202&orientation=portrait',
      color: 'from-pink-50 to-rose-50',
      icon: 'ri-heart-pulse-line'
    },
    {
      id: 3,
      title: 'İlaç Etiketleri',
      description: 'GMP sertifikalı üretim hattımızda farmasötik sektörün en sıkı standartlarını karşılıyoruz. Her ambalaj için seri numarası, güvenlik hologramı ve karekod sistemi oluşturarak sahtecilikle mücadeleye destek veriyoruz.',
      image: 'https://readdy.ai/api/search-image?query=pharmaceutical%20packaging%20closeup%20showing%20medicine%20blister%20packs%20pill%20bottles%20with%20precise%20printed%20dosage%20labels%20barcode%20and%20safety%20seal%20on%20clean%20white%20lab%20counter%20clinical%20setting%20sterile%20environment%20product%20photography&width=600&height=700&seq=svc-pharma-v2-203&orientation=portrait',
      color: 'from-blue-50 to-cyan-50',
      icon: 'ri-capsule-line'
    },
    {
      id: 4,
      title: 'Endüstriyel Etiketler',
      description: 'Motor yağı, asit, solvent ve 150°C sıcaklığa dayanıklı leksan ve PET malzemelerle üretim. Makine plakası, uyarı sembolü ve CE işareti içeren karmaşık endüstriyel etiket projelerinde 20 yıllık tecrübe.',
      image: 'https://readdy.ai/api/search-image?query=factory%20floor%20with%20industrial%20machinery%20showing%20durable%20metal%20nameplates%20and%20warning%20labels%20attached%20to%20equipment%20pipes%20and%20control%20panels%20heavy%20machinery%20background%20with%20selective%20focus%20on%20safety%20labels%20professional%20industrial%20photography&width=600&height=700&seq=svc-industrial-v2-204&orientation=portrait',
      color: 'from-gray-50 to-slate-50',
      icon: 'ri-tools-line'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Başlık */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 mb-16">
          <div>
            <h2 className="text-5xl font-bold text-[#1A2332] leading-tight">
              Sektöre Özel
            </h2>
            <h2 className="text-5xl font-bold italic text-[#FF6B35] leading-tight mt-2">
              Etiket Çözümleri
            </h2>
          </div>
          <p className="text-base text-gray-600 max-w-md leading-relaxed">
            Her sektörün kendine özgü ihtiyaçlarını anlıyor, en uygun malzeme ve baskı tekniğiyle profesyonel etiket üretimi yapıyoruz.
          </p>
        </div>
        
        {/* Hizmet Kartları */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div 
              key={service.id}
              className="group bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer"
            >
              {/* Görsel */}
              <div className="relative h-72 overflow-hidden">
                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-20`}></div>
                <img 
                  src={service.image}
                  alt={`${service.title} - Profesyonel etiket baskı hizmetleri`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                  width="600"
                  height="700"
                />
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-2xl text-[#FF6B35]`}></i>
                </div>
              </div>
              
              {/* İçerik */}
              <div className="p-6 bg-white">
                <h3 className="text-xl font-semibold text-[#1A2332] mb-3">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>
                <a 
                  href="#contact"
                  className="inline-flex items-center text-sm font-medium text-[#FF6B35] hover:text-[#E55A2B] transition-colors cursor-pointer group"
                >
                  Detaylı Bilgi
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
        
        {/* Alt Bilgi */}
        <div className="mt-16 text-center">
          <p className="text-sm text-gray-500 mb-4">
            Aradığınız etiket türünü bulamadınız mı?
          </p>
          <a 
            href="#contact"
            className="inline-flex items-center px-6 py-3 text-sm font-semibold text-[#FF6B35] border-2 border-[#FF6B35] rounded-full hover:bg-[#FF6B35] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Özel Çözüm Talep Edin
            <i className="ri-customer-service-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}